import { apiSlice } from './apiSlice';

// Base URL for Garmin routes (same base as API)
const GARMIN_URL = import.meta.env.VITE_API_BASE_URL
  ? `${import.meta.env.VITE_API_BASE_URL}/garmin`
  : '/garmin';

export const garminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGarminAuthUrl: builder.mutation({
      query: () => ({ url: `${GARMIN_URL}/auth/url`, method: 'GET' }),
    }),
    getGarminStatus: builder.query({
      query: () => ({ url: `${GARMIN_URL}/status`, method: 'GET' }),
      providesTags: ['User'],
    }),
    disconnectGarmin: builder.mutation({
      query: (params = {}) => {
        const search = new URLSearchParams();
        if (params.notify) search.set('notify', 'true');
        if (params.local) search.set('local', 'true');
        const qs = search.toString();
        return { url: `${GARMIN_URL}/disconnect${qs ? `?${qs}` : ''}`, method: 'POST' };
      },
      invalidatesTags: ['User'],
    }),
    linkGarminFromRecentPush: builder.mutation({
      query: () => ({ url: `${GARMIN_URL}/link`, method: 'POST' }),
      invalidatesTags: ['User'],
    }),
    getGarminConnectedUsers: builder.query({
      query: () => ({ url: `${GARMIN_URL}/debug/connected-users`, method: 'GET' }),
      providesTags: ['User'],
    }),
    assignGarminPushUserId: builder.mutation({
      query: ({ userId, garminPushUserId, runBackfill = true }) => ({
        url: `${GARMIN_URL}/debug/assign-push-user-id`,
        method: 'POST',
        body: { userId, garminPushUserId, runBackfill },
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useGetGarminAuthUrlMutation,
  useGetGarminStatusQuery,
  useDisconnectGarminMutation,
  useLinkGarminFromRecentPushMutation,
  useGetGarminConnectedUsersQuery,
  useAssignGarminPushUserIdMutation,
} = garminApiSlice;
